<template>
  <div :style="{width:'400px'}">
    <el-dialog
      v-el-drag-dialog
      :visible.sync="innerVisible"
      :title="$t('SeaExport.SelectCodeRule')"
      :close-on-click-modal="false"
      class="app-main-inner"
      width="430px"
    >
      <cargo-ag-grid
        :show-side-bar="false"
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :row-data="rowData"
        :style="{width:'350px',height:'200px'}"
        @gridReady="params=>gridApi=params.api"
      />
      <span slot="footer">
        <el-button no="confirm" type="primary" @click="selectedHandler">{{ $t('common.btn.confirm') }}</el-button>
        <el-button no="close" @click="innerVisible=false">{{ $t('common.btn.close') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>

export default {
  name: 'JobNoRuleSelector',
  props: {
    visible: { type: Boolean, required: true },
    rules: { type: Array }
  },
  data() {
    return {
      innerVisible: false,
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        onRowDoubleClicked: this.selectedHandler
      },
      gridParams: {},
      gridApi: {},
      columnDefs: [
        {
          headerName: this.$t('SeaExport.CodeRuleDesc'),
          field: 'ruleDesc',
          suppressMenu: true,
          width: 340
        }
      ],
      rowData: []
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
      if (newVal) {
        this.rowData = this.rules
      }
    },
    innerVisible(newVal) {
      if (!newVal) {
        this.gridApi.clearFocusedCell()
        this.rowData = []
      }
      this.$emit('update:visible', newVal)
    }
  },
  created() {
    if (this.visible) {
      this.innerVisible = true
      this.rowData = this.rules
    }
  },
  methods: {
    selectedHandler() {
      let currentRow = null
      const cell = this.gridApi.getFocusedCell()
      if (cell) {
        currentRow = this.rowData[cell.rowIndex]
      }
      if (!currentRow) {
        this.$message.warning(this.$t('SeaExport.SelectCodeRule'))
        return
      }
      this.$emit('selectedBack', currentRow)
      this.innerVisible = false
    }
  }
}
</script>

<style>
</style>
